module.exports = __webpack_public_path__ + "static/media/hamburgerMenu.4c4d750b.svg";